import * as React from 'react';

import Breadcrumbs from '../../components/layout/Breadcrumbs';

import { Wrapper } from './styles';

export function AppLayout({ children }) {
  return <Wrapper>{children}</Wrapper>;
}
